import React, { useEffect, useState } from "react";
import styles from "./OrderReport.module.css";
import DatePicker from "react-datepicker";
import { HiSearchCircle } from "react-icons/hi";
import {
  AiOutlineShoppingCart,
  AiOutlineCheckCircle,
  AiOutlineRollback,
  AiOutlineCloseCircle,
  AiOutlineInbox
} from "react-icons/ai";
import myAxios from "../AxiosUrl";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function OrderReport() {
  const [DateFrom, setDateFrom] = useState(new Date());
  DateFrom.setHours(0);
  DateFrom.setMinutes(0);
  DateFrom.setSeconds(0);

  const [DateTo, setDateTo] = useState(new Date());
  DateTo.setHours(0);
  DateTo.setMinutes(0);
  DateTo.setSeconds(0);

  const [DateSearch, setDateSearch] = useState(false);
  const [RefreshSe, setRefreshSe] = useState(1);
  const uid = localStorage.getItem("id");

  const [Totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setPageLimit] = useState(20);
  const [pData, setPdata] = useState([]);
  const [CalData, setCalData] = useState();

  const [searchN, setSearchNum] = useState("");

  const [orderStatus, setOrderStatus] = useState();
  const [loading, setLoading] = useState(true);
  const [FilterDate, setFilterDate] = useState("Today");
  const [selectAll, setSelectAll] = useState(false);
  console.log(CalData);
  const getData = () => {
    setLoading(true);
    const Nurl = `get-order-details?searchN=${searchN}&orderStatus=${orderStatus}&uid=${uid}&page=${page}&limit=${limit}&FilterDate=${FilterDate}&DateFrom=${DateFrom}&DateTo=${DateTo}&DateSearch=${DateSearch}`;
    myAxios
      .get(Nurl)
      .then((res) => {
        // Handle response - check if res.data is an array or has nested data
        const dataArray = Array.isArray(res.data) ? res.data : (res.data.data || res.data.orders || []);
        const totalCount = res.data.total || dataArray.length;

        setPdata(dataArray);
        setTotalPage(totalCount);
        setLoading(false);
        setDateSearch(false);

        let areturn = 0;
        let cancel = 0;
        let qnt = 0;
        let delivered = 0;

        // Safely map over the array
        if (Array.isArray(dataArray)) {
          dataArray.forEach((data) => {
            qnt += data.qnt || 0;
            cancel += data.cancel || 0;
            areturn += data.return || 0;
            delivered += data.delivered || 0;
          });
        }

        setCalData({
          return: areturn,
          cancel,
          qnt,
          delivered,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getData();
  }, [FilterDate, RefreshSe, page, limit]);

  const renderDataSkeleton = () => (
    <>
      {/* Skeleton Stats */}
      <div className={styles["skeleton-stats-section"]}>
        <div className={styles["skeleton-stats-grid"]}>
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className={styles["skeleton-stat-card"]}>
              <div className={styles.skeleton} style={{width: '40px', height: '40px', borderRadius: '8px', flexShrink: 0}}></div>
              <div style={{flex: 1}}>
                <div className={styles.skeleton} style={{width: '60px', height: '22px', marginBottom: '6px'}}></div>
                <div className={styles.skeleton} style={{width: '50px', height: '14px'}}></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Skeleton Table */}
      <div className={styles["skeleton-table-section"]}>
        <div className={styles["skeleton-table-header"]}>
          <div className={styles.skeleton} style={{width: '50px', height: '14px'}}></div>
          <div className={styles.skeleton} style={{width: '60px', height: '14px'}}></div>
          <div className={styles.skeleton} style={{width: '40px', height: '14px'}}></div>
          <div className={styles.skeleton} style={{width: '70px', height: '14px'}}></div>
          <div className={styles.skeleton} style={{width: '55px', height: '14px'}}></div>
          <div className={styles.skeleton} style={{width: '55px', height: '14px'}}></div>
        </div>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <div key={i} className={styles["skeleton-table-row"]}>
            <div className={styles.skeleton} style={{width: '80px', height: '80px', borderRadius: '8px'}}></div>
            <div className={styles.skeleton} style={{width: '70%', height: '16px'}}></div>
            <div className={styles.skeleton} style={{width: '40px', height: '16px', margin: '0 auto'}}></div>
            <div className={styles.skeleton} style={{width: '40px', height: '16px', margin: '0 auto'}}></div>
            <div className={styles.skeleton} style={{width: '40px', height: '16px', margin: '0 auto'}}></div>
            <div className={styles.skeleton} style={{width: '40px', height: '16px', margin: '0 auto'}}></div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <div className={styles["shopify-container"]}>
      {/* Filters Section - always visible */}
      <div className={styles["filters-section"]}>
        <div className={styles["filters-row"]}>
          <div className={styles["shopify-date-filter"]}>
            <select
              name="filterData"
              className={styles["shopify-select"]}
              onChange={(e) => setFilterDate(e.target.value)}
            >
              <option value="Today">Today</option>
              <option value="Yesterday">Yesterday</option>
              <option value="7 Days">Week</option>
              <option value="Month">Month</option>
              <option value="Last Month">Last Month</option>
              <option value="all">All Orders</option>
            </select>
          </div>

          <div className={styles["shopify-date-picker"]}>
            <div className={styles["date-range-container"]}>
              <DatePicker
                selected={DateFrom}
                onChange={(date) => setDateFrom(date)}
                className={styles["shopify-date-input"]}
                dateFormat="MM/dd/yyyy"
              />
              <span className={styles["date-separator"]}>to</span>
              <DatePicker
                selected={DateTo}
                onChange={(date) => setDateTo(date)}
                className={styles["shopify-date-input"]}
                dateFormat="MM/dd/yyyy"
              />
              <button
                className={styles["shopify-search-btn"]}
                onClick={() => {
                  setDateSearch(true);
                  setRefreshSe(RefreshSe + 1);
                }}
              >
                <HiSearchCircle size={18} />
                Search
              </button>
            </div>
          </div>
        </div>
      </div>

      {loading ? renderDataSkeleton() : (
        <>
          {/* Stats Cards */}
          <div className={styles["shopify-stats-section"]}>
            <div className={styles["stats-cards"]}>
              <div className={styles["stat-card"]}>
                <div className={styles["stat-icon"]}>
                  <AiOutlineShoppingCart size={24} />
                </div>
                <div className={styles["stat-content"]}>
                  <div className={styles["stat-value"]}>{CalData?.qnt || 0}</div>
                  <div className={styles["stat-label"]}>Sale</div>
                </div>
              </div>
              <div className={styles["stat-card"]}>
                <div className={styles["stat-icon"]}>
                  <AiOutlineCheckCircle size={24} />
                </div>
                <div className={styles["stat-content"]}>
                  <div className={styles["stat-value"]}>{CalData?.delivered || 0}</div>
                  <div className={styles["stat-label"]}>Delivered</div>
                </div>
              </div>
              <div className={styles["stat-card"]}>
                <div className={styles["stat-icon"]}>
                  <AiOutlineRollback size={24} />
                </div>
                <div className={styles["stat-content"]}>
                  <div className={styles["stat-value"]}>{CalData?.return || 0}</div>
                  <div className={styles["stat-label"]}>Return</div>
                </div>
              </div>
              <div className={styles["stat-card"]}>
                <div className={styles["stat-icon"]}>
                  <AiOutlineCloseCircle size={24} />
                </div>
                <div className={styles["stat-content"]}>
                  <div className={styles["stat-value"]}>{CalData?.cancel || 0}</div>
                  <div className={styles["stat-label"]}>Cancel</div>
                </div>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className={styles["table-section"]}>
            <TableContainer component={Paper} className={styles["shopify-table-wrapper"]}>
              <Table className={styles["shopify-table"]} aria-label="simple table">
                <TableHead className={styles["table-header"]}>
                  <TableRow className={styles["header-row"]}>
                    <TableCell align="center" className={styles["header-cell"]}>Photo</TableCell>
                    <TableCell align="center" className={styles["header-cell"]}>Name</TableCell>
                    <TableCell align="center" className={styles["header-cell"]}>Sale</TableCell>
                    <TableCell align="center" className={styles["header-cell"]}>Delivered</TableCell>
                    <TableCell align="center" className={styles["header-cell"]}>Return</TableCell>
                    <TableCell align="center" className={styles["header-cell"]}>Cancel</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(!Array.isArray(pData) || pData.length <= 0) ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" style={{ padding: "60px 20px" }}>
                        <div style={{ fontSize: "48px", marginBottom: "16px", color: "#6b7280" }}>
                          <AiOutlineInbox size={64} />
                        </div>
                        <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#202223", margin: "0 0 8px 0" }}>
                          No data available
                        </h3>
                        <p style={{ fontSize: "14px", color: "#6d7175", margin: "0" }}>
                          Try adjusting your filters or date range
                        </p>
                      </TableCell>
                    </TableRow>
                  ) : (
                    Array.isArray(pData) && pData.map((data, index) => {
                      function calculateReturnPercentage(shipped, returned) {
                        const res = Math.floor((returned / shipped) * 100);
                        return res;
                      }
                      return (
                        <TableRow
                          className={styles["table-row"]}
                          key={index}
                        >
                          <TableCell component="th" scope="row" align="center" className={styles["table-cell"]}>
                            <img
                              src={data.image}
                              height={80}
                              width={80}
                              alt={data.colorName}
                              style={{
                                borderRadius: "8px",
                                objectFit: "cover",
                                border: "2px solid #e5e7eb"
                              }}
                            />
                          </TableCell>
                          <TableCell align="center" className={styles["table-cell"]}>
                            <span style={{ fontWeight: "600", color: "#202223" }}>{data.colorName}</span>
                          </TableCell>
                          <TableCell align="center" className={styles["table-cell"]}>
                            <span style={{ fontWeight: "600", color: "#202223" }}>{data.qnt}</span>
                          </TableCell>
                          <TableCell align="center" className={styles["table-cell"]}>
                            <span style={{ fontWeight: "600", color: "#008060" }}>{data.delivered}</span>
                          </TableCell>
                          <TableCell align="center" className={styles["table-cell"]}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                              <span style={{ fontWeight: "600", color: "#dc2626" }}>{data.return}</span>
                              <span style={{ fontSize: "12px", color: "#6b7280" }}>
                                {data.return == 0 ? "0" : calculateReturnPercentage(data.delivered, data.return)}%
                              </span>
                            </div>
                          </TableCell>
                          <TableCell align="center" className={styles["table-cell"]}>
                            <span style={{ fontWeight: "600", color: "#f59e0b" }}>{data.cancel}</span>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* Pagination Section */}
          {Array.isArray(pData) && pData.length > 0 && (
            <div className={styles["pagination-section"]}>
              <div className={styles["pagination-info"]}>
                <span>
                  Showing {((page - 1) * limit) + 1} to {Math.min(page * limit, Totalpage || 0)} of {Totalpage || 0} products
                </span>
                <select
                  className={styles["limit-select"]}
                  value={limit}
                  onChange={(e) => {
                    setPageLimit(parseInt(e.target.value));
                    setPage(1);
                  }}
                >
                  <option value={10}>10 per page</option>
                  <option value={20}>20 per page</option>
                  <option value={50}>50 per page</option>
                  <option value={100}>100 per page</option>
                </select>
              </div>

              <div className={styles["pagination-controls"]}>
                <button
                  className={styles["page-btn"]}
                  onClick={() => setPage(1)}
                  disabled={page === 1}
                >
                  First
                </button>
                <button
                  className={styles["page-btn"]}
                  onClick={() => setPage(page - 1)}
                  disabled={page === 1}
                >
                  Previous
                </button>

                <div className={styles["page-numbers"]}>
                  {(() => {
                    const totalPages = Math.max(1, Math.ceil((Totalpage || 0) / limit));
                    const maxButtons = Math.min(5, totalPages);

                    if (maxButtons <= 0) return null;

                    return [...Array(maxButtons)].map((_, idx) => {
                      let pageNum;

                      if (totalPages <= 5) {
                        pageNum = idx + 1;
                      } else if (page <= 3) {
                        pageNum = idx + 1;
                      } else if (page >= totalPages - 2) {
                        pageNum = Math.max(1, totalPages - 4 + idx);
                      } else {
                        pageNum = page - 2 + idx;
                      }

                      return (
                        <button
                          key={`page-${pageNum}`}
                          className={`${styles["page-btn"]} ${page === pageNum ? styles["active"] : ""}`}
                          onClick={() => setPage(pageNum)}
                        >
                          {pageNum}
                        </button>
                      );
                    });
                  })()}
                </div>

                <button
                  className={styles["page-btn"]}
                  onClick={() => setPage(page + 1)}
                  disabled={page >= Math.max(1, Math.ceil((Totalpage || 0) / limit))}
                >
                  Next
                </button>
                <button
                  className={styles["page-btn"]}
                  onClick={() => setPage(Math.max(1, Math.ceil((Totalpage || 0) / limit)))}
                  disabled={page >= Math.max(1, Math.ceil((Totalpage || 0) / limit))}
                >
                  Last
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default OrderReport;
